export default "__VITE_ASSET__DmTv57yM__"